export const calendarBlockedPopUpErrorMessage =
  "Oops, it looks like you have popup blockers that prevent us to view the consent screen.\n\nTo resolve this issue, you can usually do this by clicking on the blocker icon in your browser's address bar and allowing popups for our site.";

export const calendarAccessDeniedErrorMessage =
  "We were not able to access your calendar. If you'd like to use this feature, please enable calendar access in the settings. You can do this by going to Settings > Calendar";

export const calendarSignInUnavailableErrorMessage =
  "We couldn't reach Google sign-in. Please check your connection or disable any privacy/ad blockers and try again.";

export const calendarScopes = [
  'https://www.googleapis.com/auth/userinfo.email',
  'https://www.googleapis.com/auth/calendar',
];

export const calendarAndGmailReadonlyScopes = [...calendarScopes, 'https://www.googleapis.com/auth/gmail.readonly'];
